const config = {
	env: "local",
	apiUrl: "https://api.linkdpartners.com/admin/v1",

};




export default config;
